import * as UI from "@iyk/ui"

import { Checkbox, type CheckboxProps } from "./Checkbox.tsx"

export type CheckboxFieldProps = CheckboxProps & {
  name: string
  children: React.ReactNode
  validationMessage?: string
  required?: boolean
}

export const CheckboxField = ({
  children,
  name,
  validationMessage,
  required,
  id,
  disabled,
  ...props
}: CheckboxFieldProps) => {
  return (
    <UI.Field name={name} validationMessage={validationMessage} required={required}>
      <span className="flex flex-row items-center gap-2">
        <Checkbox disabled={disabled} id={id} name={name} {...props} />
        <label data-disabled={disabled} htmlFor={id} className="text-sm data-[disabled]:text-gray-8">
          {children}
        </label>
      </span>

      <UI.Validity />
    </UI.Field>
  )
}
